import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseSellReport() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();
  const { toGregorian, toSolar } = require("jdate-convert");

  function validate(state, setter) {
    let errorState = {
      productID: isEmpty(state.productID),
      categoryID: isEmpty(state.categoryID),
      groupID: isEmpty(state.groupID),
      brandID: isEmpty(state.brandID),
      date1: isEmpty(state.date1),
      date2: isEmpty(state.date2),
    };

    setter(errorState);

    if (
      errorState.productID ||
      errorState.categoryID ||
      errorState.groupID ||
      errorState.brandID
    ) {
      enqueueSnackbar("لطفا یک فیلتر را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else if (errorState.date1 || errorState.date2) {
      enqueueSnackbar("لطفا تاریخ را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetSellReport = (bool) => {
    MyAxios.get(`Admin_ProductSellReport`, {
      headers: {
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        // callback(response.data.resault);
      }
    });
  };

  const GetProductList = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductSellReport/List`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetItemReport = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductSellReport/Item`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };
  const GetItemReportusers = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductSellReport/Item/users`, data).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  return {
    GetSellReport,
    GetProductList,
    GetItemReport,
    validate,
    GetItemReportusers,
  };
}
